import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Add from "@material-ui/icons/Add";
import Cancel from "@material-ui/icons/Cancel";
import Delete from "@material-ui/icons/Delete";
import Save from "@material-ui/icons/Save";
import PropTypes from "prop-types";
import React, {memo, useState} from "react";
import BootstrapInput from "./common/BootstrapInput";

const useStyles = makeStyles({
    tableRow: {
        cursor: "pointer"
    },
    tableCell: {
        padding: "8px 0px 8px 8px"
    }
});

const HeaderMappingTable = ({languageCodes, onAdd, onDelete, onReset, onUpdate}) => {
    const classes = useStyles();
    const [selectedName, setSelectedName] = useState("");
    const [updateLanguageCode, setUpdateLanguageCode] = useState({
        name: "",
        android: "",
        ios: "",
        flutter: "",
        i18next: "",
        phpLaravel: ""
    });
    const [createLanguageCode, setCreateLanguageCode] = useState({
        name: "",
        android: "",
        ios: "",
        flutter: "",
        i18next: "",
        phpLaravel: ""
    });

    const handleReset = () => {
        setSelectedName("");
        setUpdateLanguageCode({
            name: "",
            android: "",
            ios: "",
            flutter: "",
            i18next: "",
            phpLaravel: ""
        });
        onReset();
    };

    const handleRowClick = languageCode => {
        setSelectedName(languageCode.name);
        setUpdateLanguageCode(languageCode);
    };

    const handleUpdate = () => {
        const newUpdateLanguageCode = {...updateLanguageCode};
        newUpdateLanguageCode.name = newUpdateLanguageCode.name.trim();
        newUpdateLanguageCode.android = newUpdateLanguageCode.android.trim();
        newUpdateLanguageCode.ios = newUpdateLanguageCode.ios.trim();
        newUpdateLanguageCode.flutter = newUpdateLanguageCode.flutter.trim();
        newUpdateLanguageCode.i18next = newUpdateLanguageCode.i18next.trim();
        newUpdateLanguageCode.phpLaravel = newUpdateLanguageCode.phpLaravel.trim();
        if (newUpdateLanguageCode.name.length <= 0) return alert("Header should not be empty.");
        if (onUpdate(selectedName, newUpdateLanguageCode)) {
            setSelectedName("");
            setUpdateLanguageCode({
                name: "",
                android: "",
                ios: "",
                flutter: "",
                i18next: "",
                phpLaravel: ""
            });
        } else {
            setUpdateLanguageCode(newUpdateLanguageCode);
        }
    };

    const handleCancel = () => {
        setSelectedName("");
        setUpdateLanguageCode({
            name: "",
            android: "",
            ios: "",
            flutter: "",
            i18next: "",
            phpLaravel: ""
        });
    };

    const handleUpdateInputChange = event => {
        const newUpdateLanguageCode = {...updateLanguageCode};
        newUpdateLanguageCode[event.target.name] = event.target.value;
        setUpdateLanguageCode(newUpdateLanguageCode);
    };

    const handleCreateInputChange = event => {
        const newCreateLanguageCode = {...createLanguageCode};
        newCreateLanguageCode[event.target.name] = event.target.value;
        setCreateLanguageCode(newCreateLanguageCode);
    };

    const handleAdd = () => {
        const newCreateLanguageCode = {...createLanguageCode};
        newCreateLanguageCode.name = newCreateLanguageCode.name.trim();
        newCreateLanguageCode.android = newCreateLanguageCode.android.trim();
        newCreateLanguageCode.ios = newCreateLanguageCode.ios.trim();
        newCreateLanguageCode.flutter = newCreateLanguageCode.flutter.trim();
        newCreateLanguageCode.i18next = newCreateLanguageCode.i18next.trim();
        newCreateLanguageCode.phpLaravel = newCreateLanguageCode.phpLaravel.trim();
        if (newCreateLanguageCode.name.length <= 0) return alert("Header should not be empty.");
        if (onAdd(newCreateLanguageCode)) {
            setCreateLanguageCode({
                name: "",
                android: "",
                ios: "",
                flutter: "",
                i18next: "",
                phpLaravel: ""
            });
        } else {
            setCreateLanguageCode(newCreateLanguageCode);
        }
    };

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Header</TableCell>
                    <TableCell>Android</TableCell>
                    <TableCell>iOS</TableCell>
                    <TableCell>Flutter</TableCell>
                    <TableCell>i18next</TableCell>
                    <TableCell>PHP Laravel</TableCell>
                    <TableCell align="center">
                        <Button onClick={handleReset}
                                variant="contained"
                                color="primary">
                            Reset
                        </Button>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {languageCodes.map(value => {
                    if (value.name === selectedName) return (
                        <TableRow key={selectedName}
                                  selected>
                            <TableCell className={classes.tableCell}
                                       padding="none">
                                <BootstrapInput placeholder={updateLanguageCode.name}
                                                value={updateLanguageCode.name}
                                                name="name"
                                                onChange={handleUpdateInputChange}
                                                fullWidth/>
                            </TableCell>
                            <TableCell className={classes.tableCell}
                                       padding="none">
                                <BootstrapInput placeholder={updateLanguageCode.android}
                                                value={updateLanguageCode.android}
                                                name="android"
                                                onChange={handleUpdateInputChange}
                                                fullWidth/>
                            </TableCell>
                            <TableCell className={classes.tableCell}
                                       padding="none">
                                <BootstrapInput placeholder={updateLanguageCode.ios}
                                                value={updateLanguageCode.ios}
                                                name="ios"
                                                onChange={handleUpdateInputChange}
                                                fullWidth/>
                            </TableCell>
                            <TableCell className={classes.tableCell}
                                       padding="none">
                                <BootstrapInput placeholder={updateLanguageCode.flutter}
                                                value={updateLanguageCode.flutter}
                                                name="flutter"
                                                onChange={handleUpdateInputChange}
                                                fullWidth/>
                            </TableCell>
                            <TableCell className={classes.tableCell}
                                       padding="none">
                                <BootstrapInput placeholder={updateLanguageCode.i18next}
                                                value={updateLanguageCode.i18next}
                                                name="i18next"
                                                onChange={handleUpdateInputChange}
                                                fullWidth/>
                            </TableCell>
                            <TableCell className={classes.tableCell}
                                       padding="none">
                                <BootstrapInput placeholder={updateLanguageCode.phpLaravel}
                                                value={updateLanguageCode.phpLaravel}
                                                name="phpLaravel"
                                                onChange={handleUpdateInputChange}
                                                fullWidth/>
                            </TableCell>
                            <TableCell padding="none" align="center">
                                <IconButton aria-label="Update"
                                            onClick={handleUpdate}
                                            size="small">
                                    <Save/>
                                </IconButton>
                                <IconButton aria-label="Delete"
                                            onClick={() => onDelete(value.name)}
                                            size="small">
                                    <Delete/>
                                </IconButton>
                                <IconButton aria-label="Cancel"
                                            onClick={handleCancel}
                                            size="small">
                                    <Cancel/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    );
                    else return (
                        <TableRow hover
                                  className={classes.tableRow}
                                  key={value.name}
                                  onClick={() => handleRowClick(value)}>
                            <TableCell>{value.name}</TableCell>
                            <TableCell>{value.android}</TableCell>
                            <TableCell>{value.ios}</TableCell>
                            <TableCell>{value.flutter}</TableCell>
                            <TableCell>{value.i18next}</TableCell>
                            <TableCell>{value.phpLaravel}</TableCell>
                            <TableCell/>
                        </TableRow>
                    );
                })}
                <TableRow key="">
                    <TableCell className={classes.tableCell}
                               padding="none">
                        <BootstrapInput placeholder="Header"
                                        value={createLanguageCode.name}
                                        name="name"
                                        onChange={handleCreateInputChange}
                                        fullWidth/>
                    </TableCell>
                    <TableCell className={classes.tableCell}
                               padding="none">
                        <BootstrapInput placeholder="Android"
                                        value={createLanguageCode.android}
                                        name="android"
                                        onChange={handleCreateInputChange}
                                        fullWidth/>
                    </TableCell>
                    <TableCell className={classes.tableCell}
                               padding="none">
                        <BootstrapInput placeholder="iOS"
                                        value={createLanguageCode.ios}
                                        name="ios"
                                        onChange={handleCreateInputChange}
                                        fullWidth/>
                    </TableCell>
                    <TableCell className={classes.tableCell}
                               padding="none">
                        <BootstrapInput placeholder="Flutter"
                                        value={createLanguageCode.flutter}
                                        name="flutter"
                                        onChange={handleCreateInputChange}
                                        fullWidth/>
                    </TableCell>
                    <TableCell className={classes.tableCell}
                               padding="none">
                        <BootstrapInput placeholder="i18next"
                                        value={createLanguageCode.i18next}
                                        name="i18next"
                                        onChange={handleCreateInputChange}
                                        fullWidth/>
                    </TableCell>
                    <TableCell className={classes.tableCell}
                               padding="none">
                        <BootstrapInput placeholder="PHP Laravel"
                                        value={createLanguageCode.phpLaravel}
                                        name="phpLaravel"
                                        onChange={handleCreateInputChange}
                                        fullWidth/>
                    </TableCell>
                    <TableCell align="center" padding="none">
                        <IconButton aria-label="Add"
                                    onClick={handleAdd}
                                    size="small">
                            <Add/>
                        </IconButton>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
};

HeaderMappingTable.propTypes = {
    languageCodes: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        android: PropTypes.string,
        ios: PropTypes.string,
        flutter: PropTypes.string,
        i18next: PropTypes.string,
        phpLaravel: PropTypes.string
    })),
    onReset: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired
};

export default memo(HeaderMappingTable);
